import {SERVICE_GROUP_CREATE, SERVICE_GROUP_UPDATE, SERVICE_GROUP_DELETE} from './available'
import _ from 'lodash'

export default {
  [SERVICE_GROUP_CREATE](state, serviceGroup) {
    state.availableServiceGroups.unshift(serviceGroup)
  },
  [SERVICE_GROUP_UPDATE](state, serviceGroup) {
    let serviceGroupIndex = _.findIndex(state.availableServiceGroups, function(item) {
      return item.id === serviceGroup.id
    })

    if (serviceGroupIndex < 0) {
      return
    }

    state.availableServiceGroups.splice(serviceGroupIndex, 1, serviceGroup)
  },
  [SERVICE_GROUP_DELETE](state, serviceGroup) {
    let serviceGroupIndex = _.findIndex(state.availableServiceGroups, function(item) {
      return item.id === serviceGroup.id
    })

    if (serviceGroupIndex < 0) {
      return
    }

    state.availableServiceGroups.splice(serviceGroupIndex, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/service-groups.js